import { defineAsyncComponent } from 'vue'

const VappType = defineAsyncComponent(() => import('./vapp-type.vue'))
const VappTypeFormModal = defineAsyncComponent(() => import('./vapp-type-form-modal.vue'))
const VappTypesSelect = defineAsyncComponent(() => import('./vapp-types-select.vue'))
const VappTypesService = defineAsyncComponent(() => import('./vapp-types-service.ts'))

export { VappType, VappTypeFormModal, VappTypesSelect, VappTypesService }

